import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "element-outline" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = {
  class: "switch-wrapper",
  style: {"flex":"3"}
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switch = _resolveComponent("Switch")!
  const _component_SelectOption = _resolveComponent("SelectOption")!
  const _component_Select = _resolveComponent("Select")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_ColorButton = _resolveComponent("ColorButton")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_InputNumber = _resolveComponent("InputNumber")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.fixed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"flex":"2"} }, "启用边框：", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Switch, {
              checked: _ctx.hasOutline,
              onChange: _cache[0] || (_cache[0] = checked => _ctx.toggleOutline(checked as boolean))
            }, null, 8, ["checked"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasOutline && _ctx.outline)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { style: {"flex":"2"} }, "边框样式：", -1)),
            _createVNode(_component_Select, {
              style: {"flex":"3"},
              value: _ctx.outline.style,
              onChange: _cache[1] || (_cache[1] = value => _ctx.updateOutline({ style: value as 'dashed' | 'solid' }))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectOption, { value: "solid" }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("实线边框")
                  ])),
                  _: 1
                }),
                _createVNode(_component_SelectOption, { value: "dashed" }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("虚线边框")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { style: {"flex":"2"} }, "边框颜色：", -1)),
            _createVNode(_component_Popover, { trigger: "click" }, {
              content: _withCtx(() => [
                _createVNode(_component_ColorPicker, {
                  modelValue: _ctx.outline.color,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = value => _ctx.updateOutline({ color: value }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_ColorButton, {
                  color: _ctx.outline.color || '#000',
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"flex":"2"} }, "边框粗细：", -1)),
            _createVNode(_component_InputNumber, {
              value: _ctx.outline.width,
              onChange: _cache[3] || (_cache[3] = value => _ctx.updateOutline({ width: value as number})),
              style: {"flex":"3"}
            }, null, 8, ["value"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}